<script setup>
/* global axios */
import { ref } from "vue";
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import Button from "dashboard/components-next/button/Button.vue";

const props = defineProps({ delivery: { type: Object, required: true } });
const emit = defineEmits(["changed"]);
const route = useRoute();
const { t } = useI18n();
const identity = ref("");
const busy = ref(false);
const error = ref("");

const update = async (action, resolution) => {
  if (busy.value) return;
  busy.value = true;
  error.value = "";
  try {
    await axios.post(
      `/api/v1/accounts/${route.params.accountId}/campaigns/${route.params.campaignId}/analytics/contacts/${props.delivery.id}/${action}`,
      { resolution, source_id: identity.value },
    );
    emit("changed");
  } catch {
    error.value = t("TEAM_LILITH.CAMPAIGN_REPORTING.ERROR");
  } finally {
    busy.value = false;
  }
};
</script>

<template>
  <div
    v-if="
      delivery.status === 'unknown' || delivery.delivery_state === 'REJECTED'
    "
    class="flex flex-col gap-2 mt-2"
  >
    <template v-if="delivery.status === 'unknown'">
      <input
        v-model="identity"
        :aria-label="t('TEAM_LILITH.CAMPAIGN_REPORTING.IDENTITY')"
        :placeholder="t('TEAM_LILITH.CAMPAIGN_REPORTING.IDENTITY')"
        class="w-full text-xs"
      />
      <Button
        size="xs"
        :disabled="busy || !identity.trim()"
        :label="t('TEAM_LILITH.CAMPAIGN_REPORTING.CONFIRM')"
        @click="update('reconcile', 'confirmed')"
      />
      <Button
        size="xs"
        variant="ghost"
        :disabled="busy"
        :label="t('TEAM_LILITH.CAMPAIGN_REPORTING.NOT_SENT')"
        @click="update('reconcile', 'not_sent')"
      />
    </template>
    <Button
      v-else
      size="xs"
      :disabled="busy"
      :label="t('TEAM_LILITH.CAMPAIGN_REPORTING.RETRY')"
      @click="update('retry')"
    />
    <span v-if="error" role="alert" class="text-xs text-n-ruby-11">{{
      error
    }}</span>
  </div>
</template>
